import { scrollAnime } from "./components/scrollAnime";
import { waveAnime } from "./components/waveAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { sliderVertical } from "./components/sliderVertical";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";
import ScrollHint from 'scroll-hint';



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    waveアニメーション用関数
    */
    //アニメーション用クラスを定義
    const waveCanvas1 = "waveCanvas1";
    waveAnime(waveCanvas1);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    const closeButtonEl = "#humberge-close";
    const headerEl = ".l-header";
    humbergerMenuButton(buttonEl, menuEl, closeButtonEl, headerEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderVEl = ".swiperVertical";
    sliderVertical(sliderVEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    const tabButtonEl = ".p-tab__list__switch";
    const tabListEl = ".p-tab__list";
    const tabContentsEl = ".p-tab__content";
    const tabWrap = ".p-tab";
    tab(tabButtonEl, tabListEl, tabContentsEl, tabWrap);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white', // white-icon will appear
    applyToParents: true,
    i18n: {
      scrollable: 'scrollable'
    }
  });

});
